// src/App1.js
import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Header from "./components1/Header";
import BottomNav from "./components1/BottomNav";
import Home from "./pages1/Home";
import Profile from "./Manage/Profile";
import Contact from "./Manage/Contact";
import Setting from "./pages1/Setting";
import SharedExpense from "./pages1/SharedExpense";
import Todo from "./pages1/Todo";
import Savings from "./pages1/Savings";
import "./App.css";

const App1 = () => {
  return (
    <div className="mobile-app-shell">
      <Header title="Expense Tracker" />
      <Routes>
        <Route path="home" element={<Home />} />
        <Route path="profile" element={<Profile />} />
        <Route path="support" element={<Contact />} />
        <Route path="settings" element={<Setting />} />
        <Route path="history" element={<Navigate to="/app1/home" replace />} />
        <Route path="sharedhistory" element={<Navigate to="/app1/sharedexpense" replace />} />
        <Route path="sharedexpense" element={<SharedExpense />} />
        <Route path="todo" element={<Todo />} />
        <Route path="savings" element={<Savings />} />
      </Routes>
      <BottomNav />
    </div>
  );
};

export default App1;
